export default __webpack_public_path__ + "static/media/python-icon.2c9e01d0.png";